import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { News } from '@interface/news';
import { CategoriesService } from '@service/categories.service';
import { LoadingService } from '@service/loading.service';
import { MobileService } from '@service/mobile.service';
import { NewsService } from '@service/news.service';
import { ToastService } from '@service/toast/toast.service';
import { UserService } from '@service/user/user.service';
import { ImpressionCounter } from '@composition_classes/impression-counter';
import { RestService } from '@service/rest/rest.service';
import { SentryService } from '@service/sentry.service';
import { StateService } from '@service/state.service';
import { DialogService } from '@service/dialog.service';
import { appConfig } from '@configuration/app-config';
import { SliderImagesService } from '@service/slider-images.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit {
  public appConfig = appConfig;

  public news: News = null;

  // IMPRESSIONCOUNTER
  // composition over inheritance
  public ImpressionCounter: ImpressionCounter = null;
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.ImpressionCounter.onScroll(event);
  }
  @ViewChildren('impressionAnchor', { read: ElementRef })
  set anchors(anchors: QueryList<ElementRef>) {
    if (anchors && this.ImpressionCounter) {
      this.ImpressionCounter.anchors = anchors;
    }
  }

  public hasSliderImages: boolean = false;

  constructor(
    private NewsService: NewsService,
    private ToastService: ToastService,
    public userService: UserService,
    public DialogService: DialogService,
    public mobileService: MobileService,
    public CategoriesService: CategoriesService,
    public StateService: StateService,
    private LoadingService: LoadingService,
    protected RestService: RestService,
    protected SentryService: SentryService,
    public sliderImagesService: SliderImagesService,
  ) {
    this.ImpressionCounter = new ImpressionCounter({
      RestService,
      SentryService,
    });
  }

  ngOnInit(): void {
    this.getEntities();

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('news');
  }

  ngAfterViewInit() {
    this.ImpressionCounter.ngAfterViewInit();
  }

  public getEntities(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.LoadingService.startLoad();

      this.NewsService.getAll()
        .then((news: News) => {
          this.news = news;
        })
        .catch(() => {
          this.ToastService.showError('Newsfeed konnte nicht abgerufen werden.');
        })
        .finally(() => {
          this.LoadingService.stopLoad();
          resolve();
        });
    });
  }
}
